<template>
  <div class="storage">
    <div class="left">
      <div v-loading="storageConfigLoading" class="storage-card">
        <div class="storage-card__header">
          <div class="storage-card__icon">
            <i class="icon-inbox-archive-line t-iconfont"></i>
          </div>
          <div class="storage-card__info">
            <div class="storage-card__title">入库方式</div>
            <div class="storage-card__desc">
              配置提炼后入库的方式及入库填写字段（不影响入库时表单必填字段的校验规则）
            </div>
          </div>
        </div>
        <div class="storage-card__body">
          <div class="storage-mode">
            <div
              class="storage-mode__item"
              :class="{
                'storage-mode__item--active': storageConfigInfo.config.warehouseType === 2
              }"
              @click="handleStorageOptionChange(2)"
            >
              <span
                class="storage-mode__radio"
                :class="{
                  'storage-mode__radio--active': storageConfigInfo.config.warehouseType === 2
                }"
              ></span>
              <span class="storage-mode__title">自动入库</span>
            </div>
            <div
              class="storage-mode__item"
              :class="{
                'storage-mode__item--active': storageConfigInfo.config.warehouseType === 1
              }"
              @click="handleStorageOptionChange(1)"
            >
              <span
                class="storage-mode__radio"
                :class="{
                  'storage-mode__radio--active': storageConfigInfo.config.warehouseType === 1
                }"
              ></span>
              <span class="storage-mode__title">手动入库</span>
            </div>
          </div>

          <transition name="fade">
            <div v-if="showAutoStorageConfigSet" class="storage-config">
              <div class="storage-field">
                <div class="storage-field__label">跟进内容展示</div>
                <div class="storage-field__content">
                  <el-switch
                    v-model="storageConfigInfo.config.viewCustomerCommunicateTag"
                    style="--el-switch-on-color: #7a52f4; --el-switch-off-color: #969799"
                    @change="updateStorageConfigInfo"
                  />
                  <span class="storage-field__tip">提炼完成后可查看跟进内容</span>
                </div>
              </div>

              <div class="storage-field storage-field--select">
                <div class="storage-field__label">可选跟进对象</div>
                <div class="storage-field__content">
                  <el-select
                    v-model="storageConfigInfo.config.followUpObject"
                    placeholder="请选择"
                    style="width: 136px"
                    @change="handleFollowUpObjectChange($event, 2)"
                  >
                    <el-option
                      v-for="item in followUpObjectOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </div>

              <div class="storage-table-group">
                <div class="storage-table-group__label">入库字段</div>
                <div class="storage-table-group__content">
                  <div v-for="table in visibleTableList" :key="table.id" class="storage-table">
                    <div class="storage-table__title">{{ table.title }}</div>
                    <div class="storage-table__main">
                      <div class="storage-table__row storage-table__row--head">
                        <div
                          v-for="column in storageConfigInfo.autoStorageConfigTableColumn"
                          :key="column.prop"
                          class="storage-table__cell"
                        >
                          {{ column.label }}
                        </div>
                      </div>
                      <div
                        v-for="row in table.data"
                        :key="`${table.id}-${row.warehouseField}`"
                        class="storage-table__row"
                      >
                        <div class="storage-table__cell storage-table__cell--title">
                          {{ row.title }}
                        </div>
                        <div class="storage-table__cell storage-table__cell--switch">
                          <el-switch
                            v-model="row.frontShow"
                            :disabled="row.disabled"
                            style="--el-switch-on-color: #7a52f4; --el-switch-off-color: #969799"
                            @change="updateStorageConfigInfo"
                          />
                        </div>
                        <div class="storage-table__cell storage-table__cell--switch">
                          <el-switch
                            v-model="row.required"
                            :disabled="isRequiredDisabled(row)"
                            style="--el-switch-on-color: #7a52f4; --el-switch-off-color: #969799"
                            @change="updateStorageConfigInfo"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="storage-config storage-config--manual">
              <div class="storage-field storage-field--select">
                <div class="storage-field__label">可选跟进对象</div>
                <div class="storage-field__content">
                  <el-select
                    v-model="storageConfigInfo.config.followUpObject"
                    placeholder="请选择"
                    style="width: 136px"
                    @change="handleFollowUpObjectChange($event, 1)"
                  >
                    <el-option
                      v-for="item in followUpObjectOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="preview-panel">
        <!-- 头部 -->
        <div class="preview-panel__header">
          <span class="preview-panel__title">预览</span>
          <span class="preview-panel__hint">预览为示例数据，仅供参考</span>
        </div>
        <!-- 内容区 -->
        <div class="preview-panel__body">
          <!-- 用户消息：音频文件卡片 -->
          <div class="preview-msg preview-msg--user">
            <div class="preview-audio-card">
              <div class="preview-audio-card__inner">
                <div class="preview-audio-card__icon">
                  <img :src="AudioLogo" />
                </div>
                <div class="preview-audio-card__info">
                  <div class="preview-audio-card__time">2025-07-08 14:28</div>
                  <div class="preview-audio-card__actions">
                    <span class="preview-audio-card__download">下载</span>
                  </div>
                </div>
              </div>
              <div class="preview-audio-card__progress">
                <i class="icon-pause-circle-line preview-audio-card__play-icon t-iconfont"></i>
                <div class="preview-audio-card__bar">
                  <div class="preview-audio-card__bar-fill"></div>
                </div>
                <span class="preview-audio-card__duration">00:20:00/00:42:32</span>
              </div>
            </div>
          </div>

          <template v-if="showAutoStorageConfigSet">
            <!-- AI 消息：准备入库 -->
            <div class="preview-msg preview-msg--ai">
              <div class="preview-ai-avatar">
                <img alt="ai" class="preview-ai-avatar__img" src="@/assets/logo.svg" />
              </div>
              <div class="preview-ai-text">
                <span class="preview-ai-text__emphasis">准备入库</span>
                <span class="preview-ai-text__secondary">，请填写入库信息</span>
              </div>
            </div>

            <!-- 表单卡片 -->
            <div class="preview-form-card">
              <div class="preview-form-field">
                <div class="preview-form-field__label">
                  分析模版<span class="preview-form-field__required">*</span>
                </div>
                <div class="preview-form-field__select">
                  <span class="preview-form-field__value">意向沟通确认</span>
                  <i class="icon-arrow-down-s-line preview-form-field__arrow t-iconfont"></i>
                </div>
              </div>
              <div class="preview-form-field">
                <div class="preview-form-field__label">
                  本次跟进对象<span class="preview-form-field__required">*</span>
                </div>
                <div class="preview-form-field__row">
                  <div
                    v-show="previewShowFollowUpObjectType"
                    class="preview-form-field__select preview-form-field__select--sm"
                  >
                    <span class="preview-form-field__value">客户</span>
                    <i class="icon-arrow-down-s-line preview-form-field__arrow t-iconfont"></i>
                  </div>
                  <div class="preview-form-field__select preview-form-field__select--lg">
                    <span class="preview-form-field__value">浙江云起科技有限公司</span>
                    <i class="icon-arrow-down-s-line preview-form-field__arrow t-iconfont"></i>
                  </div>
                </div>
              </div>
              <div v-show="previewShowSalesOpportunity" class="preview-form-field">
                <div class="preview-form-field__label">
                  销售机会<span
                    v-show="previewRequiredSalesOpportunity"
                    class="preview-form-field__required"
                    >*</span
                  >
                </div>
                <div class="preview-form-field__select">
                  <span class="preview-form-field__value">销售机会名称</span>
                  <i class="icon-arrow-down-s-line preview-form-field__arrow t-iconfont"></i>
                </div>
              </div>
              <div v-show="previewShowFollowUpMethod" class="preview-form-field">
                <div class="preview-form-field__label">
                  跟进方式<span
                    v-show="previewRequiredFollowUpMethod"
                    class="preview-form-field__required"
                    >*</span
                  >
                </div>
                <div class="preview-form-field__select">
                  <span class="preview-form-field__value">线下拜访</span>
                  <i class="icon-arrow-down-s-line preview-form-field__arrow t-iconfont"></i>
                </div>
              </div>
            </div>

            <!-- AI 消息：正在入库中 -->
            <div class="preview-msg preview-msg--ai">
              <div class="preview-ai-avatar">
                <img alt="ai" class="preview-ai-avatar__img" src="@/assets/logo.svg" />
              </div>
              <div class="preview-ai-text">
                <span class="preview-ai-text__emphasis">正在入库中</span>
                <span class="preview-ai-text__secondary">，无需在此等待</span>
              </div>
            </div>

            <!-- 入库完成卡片 -->
            <div class="preview-done-card">
              <div class="top">
                <i class="icon-checkbox-circle-fill preview-done-card__icon t-iconfont"></i>
                <span class="preview-done-card__text">入库完成</span>
              </div>
              <div v-show="storageConfigInfo.config.viewCustomerCommunicateTag" class="content">
                <markdown-view :show-string="mockMarkdown"></markdown-view>
              </div>
            </div>
          </template>
          <template v-else>
            <!-- AI 消息：准备分析 -->
            <div class="preview-msg preview-msg--ai">
              <div class="preview-ai-avatar">
                <img alt="ai" class="preview-ai-avatar__img" src="@/assets/logo.svg" />
              </div>
              <div class="preview-ai-text">
                <span class="preview-ai-text__emphasis">准备分析</span>
                <span class="preview-ai-text__secondary">，请选择提炼模版</span>
              </div>
            </div>

            <!-- 分析模版选择卡片 -->
            <div class="preview-manual-card">
              <div class="preview-manual-field">
                <div class="preview-manual-field__label">分析模版</div>
                <div class="preview-manual-field__select preview-manual-field__select--disabled">
                  <span class="preview-manual-field__value">意向沟通确认</span>
                  <i class="icon-arrow-down-s-line preview-manual-field__arrow t-iconfont"></i>
                </div>
              </div>
            </div>

            <!-- AI 消息：正在分析中 -->
            <div class="preview-msg preview-msg--ai">
              <div class="preview-ai-avatar">
                <img alt="ai" class="preview-ai-avatar__img" src="@/assets/logo.svg" />
              </div>
              <div class="preview-ai-text">
                <span class="preview-ai-text__emphasis">正在分析中</span>
                <span class="preview-ai-text__secondary">，预计 2~3 分钟，无需在此等待</span>
              </div>
            </div>

            <!-- 分析完成卡片 -->
            <div class="preview-result-card">
              <div class="preview-result-card__header">
                <i class="icon-checkbox-circle-fill preview-result-card__check-icon t-iconfont"></i>
                <span class="preview-result-card__title">分析完成</span>
              </div>
              <div class="preview-result-card__body">
                <div class="preview-result-field">
                  <div class="preview-result-field__label">
                    本次跟进对象<span class="preview-result-field__required">*</span>
                  </div>
                  <div class="preview-result-field__row">
                    <div
                      v-show="previewShowFollowUpObjectType"
                      class="preview-result-field__select preview-result-field__select--sm"
                    >
                      <span class="preview-result-field__value">客户</span>
                      <i class="icon-arrow-down-s-line preview-result-field__arrow t-iconfont"></i>
                    </div>
                    <div class="preview-result-field__select preview-result-field__select--lg">
                      <span class="preview-result-field__value">请选择</span>
                      <i class="icon-arrow-down-s-line preview-result-field__arrow t-iconfont"></i>
                    </div>
                  </div>
                </div>
                <div class="preview-result-content">
                  <markdown-view :show-string="mockMarkdown"></markdown-view>
                </div>
              </div>
              <div class="preview-result-card__footer">
                <button class="preview-result-card__btn">跟进入库</button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { getMeetingAssistantConfig, updateMeetingAssistantConfig } from '@/api'
import { ElMessage } from 'element-plus'
import AudioLogo from '@/assets/audio.png'
import MarkdownView from '@/components/markdown-view/index.vue'

const mockMarkdown = `基于这段电话录音，我对客户（发言人2）的需求进行了详细的拆解和分析。以下是核心结论：\n\n### 1. 核心需求总结\n客户正在寻找一款**B2B领域的客户管理系统（CRM）**，主要痛点在于**“获客”**和**“数据检索”**，即希望系统能提供高质量的企业线索数据，而不仅仅是管理已有的客户信息。\n\n### 2. 详细需求维度分析\n\n#### A. 业务场景与目标用户\n*   **客户类型**：**B2B模式**，主要针对**公司/企业客户ว่า**，而非个人消费者。\n*   **使用部门**新成立的一个部门预计初期有 **5人左右**使用该系统。\n*   **公司规模**：目前总人数未超过50人（属于小微企业或初创团队阶段）。\n*   **未来规划**：采取“先试用，后扩容”的策略。如果初期5人使用效果良好后续可能会增加账号数量。\n\n#### B. 功能需求重点\n*   **首要需求（强痛点）**：**数据获取与检索能力**。\n    *   客户反复询问“数据来源是怎么来的”，表明他们非常看重系统内置线索数量和质量。\n    *   期望数据覆盖面比竞品（如企查查）更广。\n    *   需要验证数据的有效性（如电话号码是否可打通）。\n*   **次要需求** **客户管理基础功能**。\n    *   虽然提到了“客户管理”，但对话重心明显偏向于前端的“获客数据”，后端的管理流程（如售后、复杂审批等暂未深入探讨）。\n\n#### C. 价格与预算敏感度\n*   **价格敏感型**：客户在沟通早期就直接询问“费用咋说”，并具体问到“5人以下”的价格档位。\n*   **决策流程**：需要先看到报价单和功能对照表，确认价格在预算范围内且功能匹配后，才愿意进入下一步演示或对接。\n*   **心理预期**：认为“人数不多，价格应该不贵”，倾向于标准化、低门槛的入门套餐。\n\n#### D. 关键疑虑与关注点\n*   **数据合规性与来源**：客户对数据来源非常警惕，担心数据的真实性和合法性（提到“全网数据”、“比企查查多”）。\n*   **有效性验证**：客户希望能在购买前测试数据的拨打有效率（销售方提出了支持提前测试，这是一个关键的转化点）。\n\n### 3. 客户画像推测\n*   **角色**：可能是新部门负责人或公司老板/高管，拥有采购决策权，关注成本和实际产出（ROI）。\n*   **行业属性**：从事ToB销售业务，依赖电话销售或陌生拜访获取客户。\n*   **性格特点**：务实、直接，不喜欢冗长的推销，更看重实质性的数据资源和性价比。\n\n### 4. 销售跟进建议（Next Steps）\n\n1.  **立即动作**：\n    *   添加微信时备注清楚：**北京联汇达科技有限公司 - [联系人姓名] - 5人版CRM咨询**。\n    *   第一时间发送**5人以下档位的详细报价单**（区分标准版/高级版/旗舰版的功能差异），突出性价比。\n\n2.  **重点突破策略**：\n    *   **主打数据优势**：不要只讲CRM的管理功能，要重点展示**“线索挖掘”**能力。提供一份同行业或同地区的样本数据供其测试拨打，用“接通率”说话。\n    *   **消除顾虑**：简要说明数据来源的合规性（如公开工商信息整合等），建立信任。\n    *   **降低门槛**：强调“小团队起步成本低”，并明确告知后续扩容的政策，消除其对“被绑定”或“后期涨价”的担忧。\n\n3.  **避坑指南**：\n    *   避免过度介绍复杂的售后管理或大型企业的定制化功能，客户目前只需要“简单、好用、能拿到号码”的工具。\n    *   不要急于安排长篇大论的系统操作演示，先让客户看报价和数据样本，确认意向后再约演示。\n\n**总结**：这是一个典型的**“数据驱动型”**小微B2B客户需求。成交的关键不在于CRM软件本身有多强大，而在于**附带的企业数据是否足够多、足够准、足够便宜**。","isLiberalRules":1,"meetingTimes":"0小时3分钟47秒`

const STORAGE_OPTION_TYPE = 4

const followUpObjectOptions = [
  { label: '客户', value: 100 },
  { label: '线索', value: 8000 },
  { label: '客户、线索', value: 1008000 }
]

const defaultCustomerFields = [
  {
    title: '销售机会',
    warehouseField: 2,
    frontShow: false,
    required: false,
    disabled: false
  },
  {
    title: '跟进方式',
    warehouseField: 3,
    frontShow: false,
    required: false,
    disabled: false
  }
]

const defaultClueFields = [
  {
    title: '跟进方式',
    warehouseField: 3,
    frontShow: false,
    required: false,
    disabled: false
  }
]

const cloneData = (data) => JSON.parse(JSON.stringify(data))

const createDefaultStorageConfig = () => ({
  warehouseType: 1,
  viewCustomerCommunicateTag: false,
  followUpObject: 100,
  fields: cloneData(defaultCustomerFields),
  clueFields: cloneData(defaultClueFields)
})

const buildBusinessTypes = (followUpObject) =>
  +followUpObject === 1008000 ? [100, 8000] : [+followUpObject]

const storageConfigLoading = ref(false)

const storageConfigInfo = ref({
  id: undefined,
  autoStorageConfigTableColumn: [
    {
      label: '入库字段',
      prop: 'title'
    },
    {
      label: '前台填写',
      prop: 'frontShow'
    },
    {
      label: '必填',
      prop: 'required'
    }
  ],
  config: createDefaultStorageConfig()
})

const tableList = ref([
  {
    id: 1,
    title: '客户',
    isShow: true,
    data: []
  },
  {
    id: 2,
    title: '线索',
    isShow: false,
    data: []
  }
])

const showAutoStorageConfigSet = computed(() => storageConfigInfo.value.config.warehouseType === 2)
const visibleTableList = computed(() => tableList.value.filter((item) => item.isShow))

// 预览区字段显示控制：根据当前可见表格中对应字段的 frontShow 状态决定
const previewShowSalesOpportunity = computed(() => {
  // 销售机会 warehouseField === 2，仅存在于客户表（fields）
  const customerTable = tableList.value.find((t) => t.id === 1)
  if (!customerTable?.isShow) return false
  const field = customerTable.data.find((f) => f.warehouseField === 2)
  return !!field?.frontShow
})

const previewShowFollowUpMethod = computed(() => {
  // 跟进方式 warehouseField === 3，仅判断第一个 isShow 为 true 的表格
  const firstVisibleTable = tableList.value.find((t) => t.isShow)
  if (!firstVisibleTable) return false
  return firstVisibleTable.data.some((f) => f.warehouseField === 3 && f.frontShow)
})

// 预览区"本次跟进对象"左侧类型选择框：仅"客户、线索"时显示
const previewShowFollowUpObjectType = computed(
  () => storageConfigInfo.value.config.followUpObject === 1008000
)

// 预览区必填 * 号控制
const previewRequiredSalesOpportunity = computed(() => {
  const customerTable = tableList.value.find((t) => t.id === 1)
  if (!customerTable?.isShow) return false
  const field = customerTable.data.find((f) => f.warehouseField === 2)
  return !!field?.required
})

const previewRequiredFollowUpMethod = computed(() => {
  const firstTable = tableList.value.find((table) => table.isShow)
  if (!firstTable) return false
  return firstTable.data.some((f) => f.warehouseField === 3 && f.required)
})

const handleTableList = (businessType, fieldsData) => {
  if (!fieldsData) {
    return
  }

  switch (+businessType) {
    case 100:
      tableList.value[0].isShow = true
      tableList.value[1].isShow = false
      tableList.value[0].data = fieldsData.fields || []
      tableList.value[1].data = []
      break
    case 8000:
      tableList.value[0].isShow = false
      tableList.value[1].isShow = true
      tableList.value[0].data = []
      tableList.value[1].data = fieldsData.clueFields || []
      break
    case 1008000:
      tableList.value[0].isShow = true
      tableList.value[1].isShow = true
      tableList.value[0].data = fieldsData.fields || []
      tableList.value[1].data = fieldsData.clueFields || []
      break
    default:
      tableList.value[0].isShow = true
      tableList.value[1].isShow = false
      tableList.value[0].data = fieldsData.fields || []
      tableList.value[1].data = []
  }
}

const matchField = (config, fieldType) => {
  config[fieldType]?.forEach((item) => {
    const field = storageConfigInfo.value.config[fieldType].find(
      (currentField) => currentField.warehouseField === item.warehouseField
    )
    if (field) {
      field.frontShow = item.frontShow
      field.required = item.required
    }
  })
}

const getStorageConfigInfo = async () => {
  try {
    storageConfigLoading.value = true
    const { result } = await getMeetingAssistantConfig({
      type: STORAGE_OPTION_TYPE
    })

    if (result?.data) {
      storageConfigInfo.value.id = result.data.id
      const config = JSON.parse(result.data.config || '{}')
      const followUpObject =
        config?.businessTypes?.length === 2 ? 1008000 : (config?.businessTypes?.[0] ?? 100)

      storageConfigInfo.value.config = {
        ...createDefaultStorageConfig(),
        warehouseType: +config.warehouseType || 1,
        viewCustomerCommunicateTag: !!config.viewCustomerCommunicateTag,
        followUpObject
      }

      matchField(config, 'fields')
      matchField(config, 'clueFields')
      handleTableList(storageConfigInfo.value.config.followUpObject, storageConfigInfo.value.config)
      return
    }

    storageConfigInfo.value.config = createDefaultStorageConfig()
    handleTableList(storageConfigInfo.value.config.followUpObject, storageConfigInfo.value.config)
  } catch (error) {
    console.error('获取入库方式配置失败', error)
  } finally {
    storageConfigLoading.value = false
  }
}

const updateStorageConfigInfo = async (type) => {
  if (type === 1) {
    storageConfigInfo.value.config = {
      ...storageConfigInfo.value.config,
      warehouseType: 1,
      viewCustomerCommunicateTag: false,
      fields: [],
      clueFields: []
    }
  }

  storageConfigInfo.value.config.businessTypes = buildBusinessTypes(
    storageConfigInfo.value.config.followUpObject
  )

  try {
    storageConfigLoading.value = true
    await updateMeetingAssistantConfig({
      id: storageConfigInfo.value.id,
      type: STORAGE_OPTION_TYPE,
      config: JSON.stringify(storageConfigInfo.value.config)
    })
    ElMessage.success('更新配置信息成功')
  } catch (error) {
    console.error('更新入库方式配置失败', error)
  } finally {
    storageConfigLoading.value = false
    await getStorageConfigInfo()
  }
}

const isRequiredDisabled = (row) => row.disabled || !row.frontShow

watch(
  () => [storageConfigInfo.value.config.fields, storageConfigInfo.value.config.clueFields],
  ([fields, clueFields]) => {
    ;[fields, clueFields].forEach((list) => {
      list.forEach((row) => {
        if (!row.frontShow) {
          row.required = false
        }
      })
    })
  },
  { deep: true }
)

const handleStorageOptionChange = (warehouseType) => {
  if (storageConfigInfo.value.config.warehouseType === warehouseType) {
    return
  }

  storageConfigInfo.value.config = {
    ...createDefaultStorageConfig(),
    warehouseType,
    followUpObject: 100
  }
  handleTableList(storageConfigInfo.value.config.followUpObject, storageConfigInfo.value.config)
  updateStorageConfigInfo(warehouseType)
}

const handleFollowUpObjectChange = (followUpObject, warehouseType) => {
  storageConfigInfo.value.config.followUpObject = followUpObject

  if (warehouseType === 2) {
    storageConfigInfo.value.config.fields = cloneData(defaultCustomerFields)
    storageConfigInfo.value.config.clueFields = cloneData(defaultClueFields)
    handleTableList(followUpObject, storageConfigInfo.value.config)
  }

  updateStorageConfigInfo(warehouseType)
}

onMounted(() => {
  getStorageConfigInfo()
})
</script>

<style lang="scss" scoped>
.storage {
  height: 100%;
  min-height: 0;
  display: flex;
  justify-content: center;

  .left {
    width: 588px;
    box-sizing: border-box;
  }

  .right {
    width: 520px;
    height: 100%;
    min-height: 0;
    margin-left: 12px;
  }
}

.storage-card {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e6eb;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);

  &__header {
    display: flex;
    align-items: center;
    padding: 12px;
    border-bottom: 1px solid #e5e6eb;
    box-sizing: border-box;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin-right: 12px;
    background: #ffffff;
    border-radius: 8px;

    .t-iconfont {
      font-size: 20px;
      color: #323233;
    }
  }

  &__info {
    width: calc(100% - 44px);
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: #323233;
  }

  &__desc {
    margin-top: 4px;
    font-size: 14px;
    line-height: 20px;
    color: #969799;
  }

  &__body {
    padding: 16px;
    box-sizing: border-box;
  }
}

.storage-mode {
  font-size: 0;

  &__item {
    display: inline-flex;
    align-items: center;
    width: 164px;
    height: 44px;
    padding: 0 16px;
    border: 1px solid #f2f3f5;
    border-radius: 12px;
    box-sizing: border-box;
    cursor: pointer;
    vertical-align: top;

    & + & {
      margin-left: 12px;
    }

    &--active {
      border-color: #7a52f4;
    }
  }

  &__radio {
    position: relative;
    width: 14px;
    height: 14px;
    margin-right: 12px;
    border: 1px solid #c8c9cc;
    border-radius: 50%;
    box-sizing: border-box;

    &--active {
      background: #7a52f4;
      border-color: #7a52f4;

      &::after {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 6px;
        height: 6px;
        content: '';
        background: #ffffff;
        border-radius: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #323233;
  }
}

.storage-config {
  margin-top: 16px;

  &--manual {
    margin-top: 16px;
  }
}

.storage-field {
  display: flex;
  align-items: center;

  & + & {
    margin-top: 16px;
  }

  &--select {
    align-items: center;
  }

  &__label {
    flex: 0 0 84px;
    margin-right: 12px;
    font-size: 14px;
    line-height: 20px;
    color: #646566;
  }

  &__content {
    display: flex;
    align-items: center;
    min-height: 20px;
  }

  &__tip {
    margin-left: 8px;
    font-size: 12px;
    line-height: 16px;
    color: #969799;
  }
}

.storage-table-group {
  display: flex;
  align-items: flex-start;
  margin-top: 16px;

  &__label {
    flex: 0 0 84px;
    margin-right: 12px;
    font-size: 14px;
    line-height: 20px;
    color: #646566;
  }

  &__content {
    width: 460px;
  }
}

.storage-table {
  & + & {
    margin-top: 8px;
  }

  &__title {
    margin-bottom: 4px;
    font-size: 12px;
    line-height: 16px;
    color: #969799;
  }

  &__main {
    overflow: hidden;
    border-radius: 4px;
  }

  &__row {
    display: flex;
    background: #ffffff;

    &--head {
      background: #f7f8fa;
    }
  }

  &__cell {
    display: flex;
    flex: 1;
    align-items: center;
    min-height: 40px;
    padding: 12px;
    font-size: 12px;
    line-height: 16px;
    color: #646566;
    border-bottom: 1px solid #f2f3f5;
    box-sizing: border-box;

    &--title {
      color: #323233;
    }

    &--switch {
      justify-content: flex-start;
    }
  }
}

:deep(.el-select__wrapper) {
  border-radius: 8px;
}

.fade-enter-active,
.fade-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* 预览面板 */
.preview-panel {
  width: 520px;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e6eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  &__header {
    display: flex;
    align-items: center;
    height: 46px;
    padding: 0 12px;
    background: #f2f3f5;
    border-bottom: 1px solid #e5e6eb;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #323233;
    margin-right: 12px;
    flex-shrink: 0;
  }

  &__hint {
    font-size: 12px;
    line-height: 16px;
    color: #969799;
  }

  &__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 16px;
    overflow-y: auto;
    background: #f2f3f5;
    box-sizing: border-box;
  }
}

/* 消息行 */
.preview-msg {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;

  &--user {
    justify-content: flex-end;
  }

  &--ai {
    justify-content: flex-start;
  }
}

/* 音频卡片 */
.preview-audio-card {
  width: 320px;
  background: #ffffff;
  border-radius: 8px;
  padding: 12px;
  box-sizing: border-box;

  &__inner {
    display: flex;
    align-items: center;
  }

  &__icon {
    width: 42px;
    height: 42px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }

  &__time {
    font-size: 14px;
    font-weight: 600;
    color: #323233;
    line-height: 20px;
    margin-bottom: 4px;
  }

  &__actions {
    display: flex;
    align-items: center;
  }

  &__download {
    font-size: 13px;
    color: #248df5;
    line-height: 18px;
  }

  &__progress {
    display: flex;
    align-items: center;
    margin-top: 8px;
  }

  &__play-icon {
    font-size: 20px;
    color: #248df5;
    flex-shrink: 0;
    margin-right: 12px;
  }

  &__bar {
    flex: 1;
    height: 6px;
    background: #f2f3f5;
    border-radius: 50px;
    overflow: hidden;
    margin-right: 8px;
  }

  &__bar-fill {
    width: 25%;
    height: 100%;
    background: #248df5;
    border-radius: 50px;
  }

  &__duration {
    font-size: 14px;
    color: #646566;
    white-space: nowrap;
    flex-shrink: 0;
  }
}

/* AI 头像 */
.preview-ai-avatar {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-right: 8px;
  margin-top: 3px;

  &__img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    object-fit: cover;
    display: block;
  }
}

/* AI 文字 */
.preview-ai-text {
  font-size: 14px;
  line-height: 20px;

  &__emphasis {
    color: #323233;
  }

  &__secondary {
    color: #969799;
  }
}

/* 表单卡片 */
.preview-form-card {
  width: 400px;
  background: #ffffff;
  border-radius: 12px;
  padding: 12px;
  box-sizing: border-box;
  margin-bottom: 16px;
}

.preview-form-field {
  display: flex;
  flex-direction: column;

  & + & {
    margin-top: 16px;
  }

  &__label {
    font-size: 14px;
    line-height: 20px;
    color: #323233;
    margin-bottom: 8px;
  }

  &__required {
    color: #f54e4e;
  }

  &__select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    padding: 0 12px;
    background: #f7f8fa;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    box-sizing: border-box;
  }

  &__row {
    display: flex;
  }

  &__select--sm {
    width: 104px;
    flex-shrink: 0;
    margin-right: 8px;
  }

  &__select--lg {
    flex: 1;
  }

  &__value {
    font-size: 14px;
    color: #646566;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
  }

  &__arrow {
    font-size: 15px;
    color: #4e5969;
    flex-shrink: 0;
    margin-left: 4px;
  }
}

/* 入库完成卡片 */
.preview-done-card {
  display: flex;
  align-items: center;
  padding: 0 12px;
  background: #ffffff;
  border-radius: 12px;
  box-sizing: border-box;
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  .top {
    height: 44px;
    display: flex;
    align-items: center;
  }
  .content {
    margin-bottom: 12px;
    border-radius: 8px;
    padding: 12px;
    background: #f7f8fa;
    width: 100%;
  }

  &__icon {
    font-size: 16px;
    color: #00c241;
    margin-right: 8px;
    flex-shrink: 0;
  }

  &__text {
    font-size: 14px;
    font-weight: 600;
    color: #323233;
    line-height: 20px;
  }
}

/* 手动入库：分析模版选择卡片 */
.preview-manual-card {
  width: 400px;
  background: #ffffff;
  border-radius: 12px;
  padding: 12px;
  box-sizing: border-box;
  margin-bottom: 16px;
}

.preview-manual-field {
  display: flex;
  flex-direction: column;

  &__label {
    font-size: 14px;
    line-height: 20px;
    color: #323233;
    margin-bottom: 8px;
  }

  &__select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    padding: 0 12px;
    background: #f7f8fa;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    box-sizing: border-box;

    &--disabled {
      background: #f7f8fa;
      cursor: not-allowed;
    }
  }

  &__value {
    font-size: 14px;
    color: #646566;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__arrow {
    font-size: 15px;
    color: #4e5969;
    flex-shrink: 0;
    margin-left: 4px;
  }
}

/* 手动入库：分析完成卡片 */
.preview-result-card {
  width: 400px;
  background: #ffffff;
  border-radius: 12px;
  box-sizing: border-box;

  &__header {
    display: flex;
    align-items: center;
    padding: 12px 12px 0;
  }

  &__check-icon {
    font-size: 16px;
    color: #00c241;
    margin-right: 8px;
    flex-shrink: 0;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #323233;
    line-height: 20px;
  }

  &__body {
    padding: 12px;
  }

  &__footer {
    padding: 0 12px 12px;
  }

  &__btn {
    display: block;
    width: 100%;
    height: 32px;
    background: #7a52f4;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    text-align: center;
    line-height: 32px;
    padding: 0;
  }
}

.preview-result-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  &__label {
    font-size: 14px;
    line-height: 20px;
    color: #323233;
    margin-bottom: 8px;
  }

  &__required {
    color: #f54e4e;
  }

  &__row {
    display: flex;
  }

  &__select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    padding: 0 12px;
    background: #ffffff;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    box-sizing: border-box;

    &--sm {
      width: 104px;
      flex-shrink: 0;
      margin-right: 8px;
    }

    &--lg {
      flex: 1;
    }
  }

  &__value {
    font-size: 14px;
    color: #c8c9cc;
    flex: 1;
    min-width: 0;
  }

  &__arrow {
    font-size: 16px;
    color: #4e5969;
    flex-shrink: 0;
    margin-left: 4px;
  }
}

.preview-result-content {
  position: relative;
  background: #f7f8fa;
  border-radius: 8px;
  padding: 12px;
  box-sizing: border-box;
  overflow: hidden;

  &__text {
    font-size: 14px;
    line-height: 20px;
    color: #323233;
    word-break: break-all;
  }
}
</style>
